import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalSearchState {
  searchText: string;
  openSearchPage: boolean;
}

const initialState: GlobalSearchState = {
  searchText: "",
  openSearchPage: false,
};

const globalSearchSlice = createSlice({
  name: "globalSearch",
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },

    setOpenSearchPage: (state, action: PayloadAction<boolean>) => {
      state.openSearchPage = action.payload;
    },
  },
});

export const { setSearchText, setOpenSearchPage } = globalSearchSlice.actions;

export default globalSearchSlice.reducer;
